if (!customElements.get('split-slideshow')) {
  class SplitSlideshow extends HTMLElement {
    constructor() {
      super();
      Motion.inView(this, this.init.bind(this), { margin: '200px 0px 200px 0px' });
    }

    get items() {
      return (this._items = this._items || Array.from(this.children));
    }

    get autoplay() {
      return this.hasAttribute('autoplay');
    }

    get speed() {
      return this.autoplay ? parseInt(this.getAttribute('autoplay-speed')) * 1000 : 5000;
    }

    init() {
      if (this.initialized) return;
      this.initialized = true;

      if (this.items.length <= 1) return;

      this.slider = new Flickity(this, {
        cellAlign: 'left',
        contain: true,
        groupCells: false,
        pageDots: false,
        prevNextButtons: false,
        accessibility: false,
        wrapAround: this.hasAttribute('wrap-around'),
        rightToLeft: theme.config.rtl,
        autoPlay: this.autoplay ? this.speed : false,
        on: {
          ready: () => this.onChange()
        }
      });

      this.slider.on('change', this.onChange.bind(this));
      this.addEventListener('slider:previous', () => this.slider.previous());
      this.addEventListener('slider:next', () => this.slider.next());
      this.addEventListener('slider:play', () => this.slider.playPlayer());
      this.addEventListener('slider:pause', () => this.slider.pausePlayer());

      if (window.Shopify && Shopify.designMode) {
        this.addEventListener('shopify:block:select', (event) =>
          this.slider.select(this.items.indexOf(event.target))
        );
      }
    }

    disconnectedCallback() {
      if (this.slider) this.slider.destroy();
    }

    select(index) {
      if (this.slider) this.slider.select(index);
    }

    onChange() {
      this.dispatchEvent(
        new CustomEvent('slider:change', {
          bubbles: true,
          detail: { currentPage: this.slider ? this.slider.selectedIndex : 0 }
        })
      );
    }
  }

  customElements.define('split-slideshow', SplitSlideshow);
}
